<template>
  <div class="cl-view-desc">
    <button
      type="button"
      class="cl-view-desc__toggle"
      :class="{ 'is-open': open }"
      :aria-expanded="open ? 'true' : 'false'"
      :aria-label="open ? 'Hide description' : 'View description'"
      :title="open ? 'Hide description' : 'View description'"
      @click="open = !open"
    >
      <i class="fas fa-question-circle" aria-hidden="true" />
    </button>
    <div v-show="open" class="cl-view-desc__body" role="region">
      <slot />
      <p v-if="guide" class="cl-view-desc__guide">
        <router-link :to="`/help/${guide.slug}`">
          <i class="fas fa-book-open" aria-hidden="true" /> Read the full guide: {{ guide.title }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchHelpHome } from '@/utils/helpApi'

export default {
  name: 'ClViewDescription',
  props: {
    /** Help Centre article for this page; the link only shows when the reader's role can open it. */
    helpSlug: { type: String, default: '' },
  },
  data() {
    return { open: false, guide: null }
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  watch: {
    open(isOpen) {
      if (isOpen && this.helpSlug && !this.guide) this.loadGuide()
    },
  },
  methods: {
    async loadGuide() {
      try {
        const home = await fetchHelpHome(this.currentUser)
        for (const section of home.sections || []) {
          const match = section.articles.find((a) => a.slug === this.helpSlug)
          if (match) {
            this.guide = match
            return
          }
        }
      } catch {
        this.guide = null
      }
    },
  },
}
</script>

<style scoped>
.cl-view-desc {
  /* Stay out of the containing block so the ? pins to the header / card corner. */
  position: static;
}

.cl-view-desc__toggle {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.85rem;
  height: 1.85rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(0, 31, 63, 0.12);
  border-radius: 999px;
  background: #fff;
  color: #64748b;
  box-shadow: 0 1px 4px rgba(0, 31, 63, 0.05);
  cursor: pointer;
  line-height: 1;
}

.cl-view-desc__toggle i {
  font-size: 0.95rem;
}

.cl-view-desc__toggle:hover,
.cl-view-desc__toggle:focus-visible,
.cl-view-desc__toggle.is-open {
  color: var(--clinch-navy, #001f3f);
  border-color: rgba(51, 181, 255, 0.4);
  background: rgba(51, 181, 255, 0.08);
  outline: none;
}

.cl-view-desc__body {
  margin-top: 0.4rem;
  max-width: 42rem;
}

.cl-view-desc__body :deep(.cl-admin-subtitle),
.cl-view-desc__body :deep(p) {
  color: #64748b;
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.5;
}

.cl-view-desc__body :deep(p + p) {
  margin-top: 0.5rem;
}

.cl-view-desc__guide {
  margin-top: 0.5rem;
  font-size: 0.9rem;
}
</style>
